import React from 'react';
import ContentLoader from 'ui_system/utilities/ContentLoader';
import { FormContainer } from 'views/anyguide/resources/formStyles';

const FormLoading = () => (
  <FormContainer>
    <ContentLoader height={40} width="90%" style={{ marginBottom: 25 }} />
    <ContentLoader height={40} width="80%" style={{ marginBottom: 25 }} />
    <ContentLoader height={40} width="90%" style={{ marginBottom: 25 }} />
    <ContentLoader height={240} width="100%" style={{ marginBottom: 25 }} />
    <div style={{ textAlign: 'right' }}>
      <ContentLoader height={40} width={120} style={{ borderRadius: 5 }} />
    </div>
  </FormContainer>
);

export default FormLoading;
